import { render, staticRenderFns } from "./ManageWebsite.vue?vue&type=template&id=0cf60580&scoped=true&"
import script from "./ManageWebsite.vue?vue&type=script&lang=js&"
export * from "./ManageWebsite.vue?vue&type=script&lang=js&"
import style0 from "./ManageWebsite.vue?vue&type=style&index=0&id=0cf60580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf60580",
  null
  
)

export default component.exports